import {
  AuthSaga,
  FirebaseSaga,
  NotificationSaga,
  SentryService,
  legalsAppRootSaga,
  parseError,
} from '@web_opxp/features';
import { LanguageSaga } from '@web_opxp/language';
import { all, call, put, spawn } from 'redux-saga/effects';
import { NetworkError, RequestAbortedError, SharedErrors } from 'web_core_library';
import { CouponSaga } from '../../coupon';
import CheckoutSaga from '../saga';

export function* handleErrorSaga(error: SharedErrors.BaseError | Error) {
  console.error(error.message);
  const action = yield call(parseError, error);
  if (action) {
    yield put(action);
  }
  if (error instanceof NetworkError || error instanceof RequestAbortedError) {
    // do not track known http errors
    return;
  }
  yield call(SentryService.captureException, error);
}

export default function* rootSaga() {
  const sagas = [AuthSaga, LanguageSaga, FirebaseSaga, NotificationSaga, CouponSaga, CheckoutSaga, legalsAppRootSaga];
  yield all(
    sagas.map((saga) =>
      spawn(function* () {
        while (true) {
          try {
            yield call(saga);
          } catch (error) {
            yield call(handleErrorSaga, error as Error | SharedErrors.BaseError);
          }
        }
      })
    )
  );
}
